import React, { PureComponent } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

import './support-blocks.scss';

export class SupportBlocks extends PureComponent {
  render() {
    const { content } = this.props;

    return (
      <div className="support-blocks">
        <ul>
          {content.map((block, key) =>
            <li key={key}>
              <div className={cn('support-block', `block-${block.type}`)}>
                <div className="support-block-value">
                  {(!!block.value) &&
                    <span
                      className="block-value"
                      dangerouslySetInnerHTML={{ __html: block.value }}
                    />
                  }

                  <span
                    className="block-unit"
                    dangerouslySetInnerHTML={{ __html: block.unit }}
                  />
                </div>

                <div
                  className="support-block-text"
                  dangerouslySetInnerHTML={{ __html: block.text }}
                />
              </div>
            </li>
          )}
        </ul>
      </div>
    );
  }
}

SupportBlocks.propTypes = {
  content: PropTypes.arrayOf(PropTypes.object)
};

export default SupportBlocks;



// WEBPACK FOOTER //
// ./src/components/Support/SupportBlocks.js